import React from 'react'

const SlideSix = () => (
  <div className="slide">
    <div className="slide-inner">
      <div className="slide-right">
        <img src="/roadmap.png" alt="Zeronomics" />
      </div>
    </div>
  </div>
)

export default SlideSix
